// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1ZINg","error":"Textarea_error__3aXmE","readonly":"Textarea_readonly__DA2hF","disabled":"Textarea_disabled__3jrWK"};